var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 11.9429L23.5 8L5.5 8L5.5 31L23.5 31L23.5 25.4143",
    stroke: "#333233",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.17 19L26.57 13.4L28 12L36 20L28 28L26.57 26.6L32.17 21L19.99 21L19.99 19L32.17 19Z",
    fill: "#333233"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExit);
export default __webpack_public_path__ + "static/media/Ic_exit.0f44110f7a915e87f77bcc0639d5cbab.svg";
export { ForwardRef as ReactComponent };